import { useMemo } from 'react'

import type { PrimaryLanguage } from 'entities/languages'
import type { Periodicity } from 'entities/periodicity'
import type { CategoriesLanguageEnum } from 'generated/graphql'
import { PeriodicityEnum } from 'generated/graphql'
import { useBrandsQueries } from 'hooks-queries/brands'
import { useBrandCategoryPageDesktop } from 'pages/BrandCategoryPage/contexts'

import { GET_BRANDS_REASONING_LOG } from './consts'

interface UseReasoningProps {
  categoryId: string
  language: PrimaryLanguage
  periodicity: Periodicity
}

export function useReasonings({ categoryId, language, periodicity }: UseReasoningProps) {
  const { soaDateFilter } = useBrandCategoryPageDesktop()
  const { data, loading, error, refetch } = useBrandsQueries({
    errorLog: GET_BRANDS_REASONING_LOG,
    queryName: 'getListReasoningOnBrandCategory',
    queryVariables: {
      filterListReasoning: {
        categoryId,
        language: language as CategoriesLanguageEnum,
        periodicity: soaDateFilter.mode === 'current' ? PeriodicityEnum.Daily : (periodicity as PeriodicityEnum),
        dateRange: soaDateFilter?.range ? soaDateFilter.range : undefined,
        dates: !soaDateFilter?.range ? soaDateFilter.dates : null,
      },
    },
    options: {
      skip: !categoryId,
    },
  })

  const reasonings = useMemo(() => {
    const reasoningList = data?.listReasoningOnBrandCategory || []
    return reasoningList
  }, [data?.listReasoningOnBrandCategory])

  const memoizedValues = useMemo(
    () => ({
      reasonings,
      isLoading: loading,
      error,
      refetch,
    }),
    [error, loading, reasonings, refetch]
  )

  return memoizedValues
}
